module.exports = __webpack_public_path__ + "img/photo-7-1.766a6a6e.webp";